import mixpanel from 'mixpanel-browser';

export const logMixpanelEvent = (eventName, eventProps) => {
  mixpanel.track(eventName, eventProps);
};
